module.exports = __webpack_public_path__ + "img/game_BG.7078c6b6.jpg";